<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert />
        <hm-spinner v-if="!ready" />
      </b-col>
    </b-row>
    <b-row v-show="ready">
      <b-col>
        <b-button type="button" variant="primary" class="px-4 mb-4" to="/training-edit">Add Training Event</b-button>
        <b-button type="button" variant="secondary" class="px-4 ml-2 mb-4" to="/training-list">View Training Events</b-button>
      </b-col>
    </b-row>
    <b-row v-show="ready">
      <b-col>Each workforce member should attend the following trainings annually at a minimum. New workforce members must receive all trainings prior to ePHI access.</b-col>
    </b-row>
    <hm-note>
      <u>Note</u>: There are no videos because compliant annual HIPAA staff training must include specific information that is custom to your office's policies and procedures.
    </hm-note>
    <b-row class="pt-4" v-show="ready">
      <b-col>
        <b-table class="p-1" responsive bordered show-empty empty-text="No Training Events" :items="trainingMapArray" :fields="columns">
          <template slot="cell(value.download)" slot-scope="data">
            <div v-for="item in data.value" :key="item.url">
              <b-button type="button" variant="primary" :href="item.url" :disabled="!item.url" target="_blank">
                <i :class="item.icon"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { trainingService } from '@/services'
import Enumerable from 'linq/linq.js'

export default {
  name: 'TrainingList',
  data() {
    return {
      columns: [{
        key: 'value.name',
        label: 'Training Topic'
      }, {
        key: 'value.duration',
        label: 'Duration'
      }, {
        key: 'value.download',
        label: 'Format'
      }],
      ready: false
    }
  },
  computed: {
    ...mapState('maps', ['trainingMap']),
    ...mapState('maps', {
      trainingMapArray(state) {
        return Enumerable.from(state.trainingMap.Training).toArray();
      }
    })
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    })
  },
  created() {
    this.ready = false;

    this.$store.dispatch('maps/fetchTrainingMap')
      .catch((err) => {
        this.alertException({ err, message: 'Error loading data.' });
      }).finally(() => {
        this.ready = true;
      })
  }
}
</script>